let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ba1Fd")).then(() => parcelRequire('5InvN'));